module.exports = __webpack_public_path__ + "static/media/team-hero.73ed7cde.jpg";